module.exports = __webpack_public_path__ + "img/img-6.774bd79b.png";